import translatePlaybookJson from 'app/shared/translation/integrations/translatePlaybookJson';

// When the integration is attached to the selected pipeline, resolve playbook
// params exactly like the pipeline page does for a staged revision (the
// attachment's pipelineVars merged into params, UI fields stripped). When not
// attached, send the live editor playbook as-is — identical to the Basic-mode
// payload.
export default function buildEditorPlaybook({ editorPlaybook, revisionMeta, attachment }) {
  if (!attachment) {
    return editorPlaybook;
  }

  return translatePlaybookJson({
    playbookJson: editorPlaybook,
    deprecatedPipelineVariables: revisionMeta.vars,
    pipelineVars: attachment.stagedRevision?.pipelineVars ?? null,
    playbookPipelineVariables: revisionMeta.pipelineVariables,
  });
}
